import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { IDrawingBase } from 'types/IDrawingBase';
import type { RootState } from 'store/store';

export interface CreateDrawingBasePayload {
  name: string;
  lotteryId: number;
  drawingTypeId: number;
}

export interface UpdateDrawingBasePayload {
  name: string;
}

export const fetchDrawingBases = createAsyncThunk<IDrawingBase[], number | undefined, { rejectValue: ApiError; state: RootState }>('drawingBases/fetchAll', async (lotteryId, { rejectWithValue }) => {
  const url = lotteryId ? `/drawing-base?lotteryId=${lotteryId}` : '/drawing-base';
  return await apiFetch<IDrawingBase[]>(url, {}, rejectWithValue);
});

export const fetchDrawingBase = createAsyncThunk<IDrawingBase, number, { rejectValue: ApiError; state: RootState }>('drawingBases/fetchOne', async (id, { rejectWithValue }) => {
  return await apiFetch<IDrawingBase>(`/drawing-base/${id}`, {}, rejectWithValue);
});

export const createDrawingBase = createAsyncThunk<IDrawingBase, CreateDrawingBasePayload, { rejectValue: ApiError; state: RootState }>('drawingBases/create', async (data, { rejectWithValue }) => {
  return await apiFetch<IDrawingBase>('/drawing-base', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const updateDrawingBase = createAsyncThunk<IDrawingBase, { id: number; data: UpdateDrawingBasePayload }, { rejectValue: ApiError; state: RootState }>('drawingBases/update', async ({ id, data }, { rejectWithValue }) => {
  return await apiFetch<IDrawingBase>(`/drawing-base/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const deleteDrawingBase = createAsyncThunk<void, number, { rejectValue: ApiError; state: RootState }>('drawingBases/delete', async (id, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing-base/${id}`, { method: 'DELETE' }, rejectWithValue);
});
